import { LitElement, html, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { getBorderColor } from './helper';
import { VoyagePlan } from '../../../src/models/vessel-planning-model';

const SubTitles = ["Weather routing status","Summary","Weather","Rating"]

@customElement('voyage-route-comparison')
export class VoyageRouteComparison extends LitElement {
    @property({ attribute: true }) routes: any = []
    @property({ attribute: true }) _plan: VoyagePlan | null = null
    @property({ attribute: true }) calculatedVals: any = []
    @property({ type: Boolean, reflect: true }) shown: boolean = false
    private _tableData: any = []
    private data = [
        ['', 'Route 1', 'Route 2', 'Route 3', 'Route 4', 'Route 5'],
        ['Weather routing status', '-', '-', '- ', '-', '-'],
        ['Summary', '', ' ', '', '', ''],
        ['Total Bunker consumption', '', ' ', '', '', ''],
        ['Distance', '-', '- ', '- ', '-', '-'],
        ['Distance pilot to pilot', '-', '- ', '- ', '-', '-'],
        ['Average speed', '-', '- ', '- ', '-', '-'],
        ['Avg. speed pilot to pilot', '-', '- ', '- ', '-', '-'],
        ['Weather', '', ' ', '', '', ''],
        ['Max wind speed', '-', '- ', '- ', '-', '-'],
        ['Max wave height ', '-', '- ', '- ', '-', '-'],
        ['Max swell height ', '-', '- ', '- ', '-', '-'],
        ['In severe weather for', '-', '- ', '- ', '-', '-'],
        ['Rating', '', ' ', '', '', ''],
    ]
    static get styles() {
        return [
            css`
                :host {
                    display: block;
                }

                .table-desc {
                    font-family: Maersk Text;
                    font-size: 16px;
                    line-height: 24px;
                    font-weight: 400;
                    margin-bottom: 16px;
                    color: #545454;
                }

                .table-header-row {
                    background-color: #f7f7f7;
                    max-width: 130px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: center;
                }

                .table-container {
                    border-radius: 5px;
                    overflow: hidden;
                    border: 1px solid #dbdbdb;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                }

                th {
                    font-size: 14px;
                    font-weight: 500;
                    text-align: start;
                    padding: 8px;
                }

                th[data-subtitle] {
                    font-weight: 500;
                    font-weight: 700;
                    font-family: 'MaerskText';
                }

                tr {
                    border-bottom: 1px solid #dbdbdb;
                }

                td {
                    font-size: 12px;
                    text-align: center;
                }

                th:first-child,
                td:first-child {
                    border-right: 1px solid #dbdbdb;
                }

                .footer {
                    display: flex;
                    justify-content: flex-end;
                    padding: 10px;
                }
                .header-row{
                    background-color: #f7f7f7;
                    max-width: 130px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: center;
                }
                .header-title{
                    display: flex;
                    gap:10px;
                    justify-content: center;
                }
                .parent-header{
                    background-color: #f7f7f7;
                }
            `,
        ]
    }

    render() {
        return html`
            <mc-modal
                heading=${`Compare Routes`}
                ?open=${this.shown}
                dimension="large"
                width="900px"
                height="auto"
                hiddenfooter
                hiddenclose
                backdropcloseactiondisabled
                escapecloseactiondisabled
                entercloseactiondisabled
            >
                ${this._renderTable()}
                <div class="footer">
                    <mc-button
                        focusstartanchor
                        appearance="primary"
                        variant="filled"
                        @click="${this._onClose}"
                        >Close</mc-button
                    >
                </div>
            </mc-modal>
        `
    }

    private _renderTable() {
        let temp = this._constructRouteData()
        return html` <div class="table-desc">
                Here you can compare all routes..
            </div>
            <div class="table-container">
                <table>
                    ${this._tableData.map(
                        (row: any[], rowIndex: number) => html`
                            <tr>
                                ${row.map(
                                    (cell, cellIndex) => html`
                                        ${rowIndex === 0 && cellIndex === 0
                                            ? html`<th class="table-header-row">
                                                  ${cell}
                                              </th>`
                                            : rowIndex === 0
                                            ? html`<th class="parent-header">
                                                <div class="header-title">
                                                <div class="header-row">${cell}</div> 
                                                <div>${SvgIcons.routeIcon(getBorderColor(cellIndex-1))}
                                            </div>
                                        </div>
                                                
                                              </th>`
                                            : cellIndex === 0
                                            ? html`<th ?data-subtitle = ${SubTitles.includes(cell)}>${cell}</th>`
                                            : html`<td>${cell}</td>`}
                                    `,
                                )}
                            </tr>
                        `,
                    )}
                </table>
            </div>`
    }

    private _onClose() {
        this.dispatchEvent(new Event('close'))
    }

    private _constructRouteData() {
        this.calculatedVals.forEach((route:any, index: number) => {
            const currentApprovedBprRouteName = this._plan?.routes.find((r) => r.routeId === this._plan?.currentSelectedRouteId && r.routeCreatedBy === 'system')?.name;
            this.data[0][index + 1] = currentApprovedBprRouteName === route.name ? 'My StarRoute' : route.name;
            this.data[3][index + 1] = route.fuel
            this.data[4][index + 1] = route.distance
            this.data[5][index + 1] = route.distancePilotToPilot
            this.data[6][index + 1] = route.avgSpeed
            this.data[7][index + 1] = route.avgSpeedPilotToPilot
            this.data[9][index + 1] = route.maxwind
            this.data[10][index + 1] = route.maxwave
            this.data[11][index + 1] = route.maxswell
            this.data[12][index + 1] = '-'
        })
         this._tableData = this.data.map(row => row.slice(0, this.calculatedVals.length+1));

    }
}
